import { render } from "./ProjectComponent.vue?vue&type=template&id=db7f0f1e"
import script from "./ProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__